module.exports = __webpack_public_path__ + "img/symbol_questionyellow.8285e5a4.png";